import { render, staticRenderFns } from "./RolesTab.vue?vue&type=template&id=3d8da4e3&scoped=true&"
import script from "./RolesTab.vue?vue&type=script&lang=js&"
export * from "./RolesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8da4e3",
  null
  
)

export default component.exports